module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-14.808215b2.jpg";